<div *ngIf="formGroup"
     [formGroup]="formGroup">
  <div *ngIf="jobTitles"
       class="row no-gutters mb-input-margin-bottom">
    <div ngbDropdown container="body" class="col-12 field-wrapper" mbFloatingLabel>
      <label [ngClass]="[isFormDisabled ? 'mb-disable-label' : '', 'dropdown-label mb-custom-label']" for="role">{{ roleLabelKey | cxTranslate }}</label>
      <button [ngClass]="[isFormDisabled ? 'mb-disable-label' : '', 'w-100 btn btn-outline-primary mb-dropdown text-left mb-selected-dropdown-value']"
              id="role" name="role" type="button"
              ngbDropdownToggle
              [disabled]="isFormDisabled">
        {{ (selectedRole?.code === constants?.ROLE) ? (roleLabelKey | cxTranslate) : (selectedRole?.name) }}
      </button>
      <div ngbDropdownMenu aria-labelledby="role-dropdown" data-cy="mb-role-input">
        <div ngbDropdownItem
             *ngFor="let jobTitle of jobTitles"
             (click)="onJobTitleChange(jobTitle)">
          {{jobTitle?.name}}
        </div>
      </div>
    </div>
  </div>
</div>
